<script>
  import DadosConsultaLoteService from '../../../../domain/leiloes/services/lote-dados-consulta'
  import { isArray } from 'lodash'

  export default {
    components: {},
    nome: 'dados-consulta-lote-detro',
    data () {
      return {
        isLoading: false,
        isLoaded: true,
        cadastroError: null,
        atualizadoSucesso: null,
        data: {
          id: null,
          consultadoNoDetran: false,
          periciaComunicadaNoDetran: false,
          extratoComunicadoDetran: false,
          conteudoExtratoDetran: null,
          respostas: [],
          lote: this.$route.params.id
        },
        respostasFormatadas: null
      }
    },
    computed: {
    },
    mounted () {
      this.start()
    },
    methods: {
      start () {
        if (this.$route.params.id) {
          this.$parent.loading(true)
          DadosConsultaLoteService.find(this.$route.params.id)
            .then((response) => {
              this.isLoaded = true
              this.data = response.data
              this.data.lote = this.data.lote.id
              this.respostasFormatadas = '[' + this.data.respostas.join(',') + ']'
              console.log(this.respostasFormatadas)
              this.respostasFormatadas = JSON.stringify(JSON.parse(this.respostasFormatadas), undefined, 4)
            })
            .catch((response) => {
              console.log(response)
            })
            .finally(() => {
              this.$parent.loading(false)
            })
        } else {
          this.isLoaded = true
          // this.$loaderOverlay.open().message('Aguarde')
        }
      },
      submit () {
        this.cadastroError = null
        this.atualizadoSucesso = false
        this.$bar.start()
        this.$parent.loading(true)
        DadosConsultaLoteService.update(this.data.id, this.data).then((response) => {
          let callbackEnd = () => {
            this.$emit('finishSubmit')
          }
          callbackEnd()
        }).catch((response) => {
          this.cadastroError = response.data.errors
          this.$nextTick(() => {
            this.$refs.error.focus()
          })
          console.log(response)
        })
        .finally(() => {
          this.$bar.finish()
          this.$parent.loading(false)
        })
      },
      printError (err) {
        if (isArray(err)) {
          return err[0]
        }
        return err
      },
      openAnotherWindow () {
        var json = this.syntaxHighlight(this.respostasFormatadas)
        var w = window.open()
        var html = `<!DOCTYPE html><head><title>003/005/007</title> <style>pre {outline: 1px solid #ccc; padding: 5px; margin: 5px; color: purple; } .string { color: #05b205; }
       .number { color: blue; } .boolean { color: darkblue; } .null { color: magenta; } .key { color: black; } h1{font-family: sans-serif; color: #7266ba}</style></head>
       <body><h1>Dados das consultas 003 / 005 / 007</h1><pre>${json}</pre></body></html>`
        w.document.writeln(html)
      },
        /* eslint-disable */
      syntaxHighlight( json ) {
        json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
            var cls = 'number'
            if (/^"/.test(match)) {
                if (/:$/.test(match)) {
                    cls = 'key'
                } else {
                    cls = 'string'
                }
            } else if (/true|false/.test(match)) {
                cls = 'boolean'
            } else if (/null/.test(match)) {
                cls = 'null'
            }
            return '<span class="' + cls + '">' + match + '</span>'
        })
      }
    }
  }
</script>

<template>
  <transition name="slide">
    <div v-if="isLoaded" class="content-transition">
      <div class="bg-light lter b-b wrapper-md">
        <div class="row">
          <div class="col-sm-6"><h1 class="m-n font-thin h3">Dados da consulta</h1></div>
        </div>
      </div>
      <div class="wrapper-md">
        <div class="panel panel-default">
          <div class="panel-body">
            <div tabindex="-1" ref="error" v-if="cadastroError !== null" class="alert alert-danger">
              <div class="m-b-sm font-bold">Erro ao registrar, corrija e tente novamente</div>
              <p v-for="(erro, key) in cadastroError">{{printError(erro)}}</p>
            </div>
            <a name="sucessMsg" id="sucessMsg" href="javascript:void(0)" ref="sucessMsg"></a>
            <div tabindex="-1" ref="error" v-if="atualizadoSucesso !== null && atualizadoSucesso" class="alert alert-success">
              <div class="font-bold">{{$route.params.id && 'Atualizado' || 'Cadastrado'}} com sucesso!</div>
            </div>
            <form @submit.prevent.stop="" class="bs-example form-horizontal">

              <div class="form-group">
                <div class="col-sm-12">
                  <label class="control-label">Consultado no DETRAN</label>
                  <input type="checkbox" v-model="data.consultadoNoDetran">
                </div>
              </div>

              <div class="form-group">
                <div class="col-sm-12">
                  <label class="control-label">Retorno da consulta no DETRAN</label>
                  <textarea style="white-space: pre-wrap;" rows="8" class="form-control" v-model="respostasFormatadas" readonly></textarea>
                  <div style="width:100%;display: flex;justify-content: flex-end;">
                    <button @click="openAnotherWindow" class="btn btn-primary">Expandir em outra aba</button>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-4 control-label">Perícia comunicada no DETRAN</label>
                <input type="checkbox" v-model="data.periciaComunicadaNoDetran">
              </div>
              <div class="form-group">
                <label class="col-sm-4 control-label">Extrato comunicado no DETRAN</label>
                <input type="checkbox" v-model="data.extratoComunicadoDetran">
              </div>
              <div class="form-group">
                <div class="col-sm-12">
                  <label class="control-label">Retorno do extrato</label>
                  <textarea rows="8" class="form-control" v-model="data.conteudoExtratoDetran"></textarea>
                </div>
              </div>

              <div class="clearfix"></div>

              <div class="row wrapper">
                <u-button @click="submit" class="btn w-xs btn-info m-r-xs">
                  <span>Atualizar</span>
                </u-button>
                <u-button class="btn w-xs m-r-xs btn-default" @click="$emit('cancel')">Cancelar</u-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// DadosConsultaLoteDetro.vue?15c78a80